import { LockIcon } from 'lucide-react';

import { SourcesAuthType } from '@api/types.gen';

import { Card } from '@@/primitives/Card';
import { Badge } from '@@/Badge';

import { GitAuthInfo } from '../../queries/useSource';

import { DetailField } from './DetailField';

interface Props {
  auth?: GitAuthInfo;
}

export function AuthWidget({ auth }: Props) {
  const methodLabel =
    auth?.type === SourcesAuthType.AUTH_TYPE_TOKEN ? 'Token' : 'Basic';

  return (
    <Card.Container>
      <Card.Header
        icon={LockIcon}
        title="Authentication"
        subtitle="Credentials used to connect to this source"
      />
      <Card.Body>
        <div className="grid grid-cols-2 gap-4">
          {auth ? (
            <>
              <DetailField label="Authentication Method">
                <Badge type="info" data-cy="source-auth-method">
                  {methodLabel}
                </Badge>
              </DetailField>
              <DetailField label="Username">
                <span
                  className="font-mono text-sm"
                  data-cy="source-auth-credentials"
                >
                  {auth.username}
                </span>
              </DetailField>
            </>
          ) : (
            <DetailField label="Authentication Method">
              <Badge type={'muted'} data-cy="source-auth-method">
                None
              </Badge>
            </DetailField>
          )}
        </div>
      </Card.Body>
    </Card.Container>
  );
}
